import React, { useState, useEffect, useRef } from 'react'
import { useNavigation } from '@react-navigation/native'
import { getPlatform } from '../utils/platformUtils'
import Constants from 'expo-constants'
import * as RootNavigation from '../components/navigation/hooks/RootNavigation'
import { useDeviceStore } from '../redux/zustand/deviceInfoStore'
import { getGoTo } from '../components/appBar/context/GoToContext'
import { useNotificationStore } from '../redux/zustand/notificationStore'
import { useBottomSheet } from '../components/customUtils/context/BottomSheetContext'
import { CommentsModalByGoToNotifications } from '../components/posts/ItemDefault'
// Importación SOLO de tipos para no traer el módulo en runtime web
import type * as NotificationsType from 'expo-notifications'

export interface PushNotificationState {
    notification?: NotificationsType.Notification
    expoPushToken?: NotificationsType.ExpoPushToken
}

export const usePushNotification = (): PushNotificationState => {
    const navigation = useNavigation()
    const { setTokenNotification } = useDeviceStore()
    const { setWithout_seeing } = useNotificationStore()
    const { setPostID } = getGoTo()
    const { openBottomSheet } = useBottomSheet()

    const [expoPushToken, setExpoPushToken] = useState<NotificationsType.ExpoPushToken | undefined>()
    const [notification, setNotification] = useState<NotificationsType.Notification | undefined>()

    // Refs se tipan de forma laxa para evitar depender en runtime del módulo
    const notificationListener = useRef<any>(null)
    const responseListener = useRef<any>(null)

    useEffect(() => {
        const os = getPlatform().OS

        if (os === 'web') {
            // En web: no importar ni registrar nada para evitar warnings y efectos secundarios
            return
        }

        let Notifications: typeof NotificationsType | null = null

        const setup = async () => {
            Notifications = (await import('expo-notifications')) as typeof NotificationsType

            // Handler de notificaciones
            Notifications.setNotificationHandler({
                handleNotification: async () => ({
                    shouldShowAlert: true,
                    shouldPlaySound: true,
                    shouldSetBadge: true,
                    shouldShowBanner: true,
                    shouldShowList: true,
                }),
            })

            // Registro permisos/token (nativo solamente)
            const { status: existingStatus } = await Notifications.getPermissionsAsync()
            let finalStatus = existingStatus
            if (existingStatus !== 'granted') {
                const { status } = await Notifications.requestPermissionsAsync()
                finalStatus = status
            }
            if (finalStatus !== 'granted') {
                // Continuamos sin token
                return
            }

            const token = await Notifications.getExpoPushTokenAsync({
                projectId: Constants.expoConfig?.extra?.eas?.projectId,
            })

            // Android channel
            if ((Notifications as any).AndroidImportance) {
                await Notifications.setNotificationChannelAsync('default', {
                    name: 'default',
                    importance: (Notifications as any).AndroidImportance.MAX,
                    vibrationPattern: [0, 250, 250, 250],
                    lightColor: '#FF231F7C',
                })
            }

            setExpoPushToken(token as any)
            setTokenNotification((token as any).data)

            // Listeners
            notificationListener.current = Notifications.addNotificationReceivedListener((n) => {
                console.log('------------------------------------ recibo notificacion --------------------------------')
                setWithout_seeing(true)
                setNotification(n as any)
            })

            responseListener.current = Notifications.addNotificationResponseReceivedListener((response) => {
                setTimeout(() => {
                    console.log('91 ------------------ response notificaion: =>> ', response)
                    const { id_content, path, someData, text, type, url, post_id, go_to } = response.notification.request.content.data as any
                    console.log('96 🚀 ~ file: usePushNotifications.tsx ~ data:', response.notification.request.content.data)

                    if (id_content && path) {
                        if (path === 'wall') {
                            setPostID(id_content)
                            navigation.goBack()
                            RootNavigation.navigate('PostsList', {})
                        } else if (path === 'comment') {
                            if (go_to && typeof go_to === 'object' && 'post_id' in go_to && 'id_content' in go_to) {
                                setPostID((go_to as any).post_id)
                                navigation.goBack()
                                RootNavigation.navigate('PostsList', {})
                                const snapPoints = ['45%']
                                setTimeout(() => {
                                    openBottomSheet(
                                        <CommentsModalByGoToNotifications post_id={(go_to as any).post_id} comment_id={(go_to as any).id_content} />,
                                        snapPoints,
                                    )
                                }, 200)
                            }
                        }
                    }
                }, 300)
            })
        }

        setup()

        return () => {
            // Remover listeners si existen
            notificationListener.current?.remove?.()
            responseListener.current?.remove?.()
        }
    }, [])

    return {
        expoPushToken,
        notification,
    }
}
